import React from 'react';
import {useSelector} from 'react-redux';
import TurnstileCaptchaRenderer from "./TurnstileCaptchaRenderer";
import DefaultCaptchaRenderer from "./DefaultCaptchaRenderer";
const GoogleRecaptchaLazy = React.lazy(() => import("./GoogleRecaptchaRenderer"));

export default function RecaptchaRenderer({
    onChange
   }){
    const recaptcha_enabled = useSelector((state:any)=>state.settings.recaptcha_enabled);
    const captcha_provider = useSelector((state:any)=>state.settings.captcha_provider);
    const recaptcha_site_key = useSelector((state:any)=>state.settings.recaptcha_site_key);
    const turnstile_site_key = useSelector((state:any)=>state.settings.turnstile_site_key);

    if(!recaptcha_enabled){
        return null;
    }
    if(captcha_provider === "recaptcha" && recaptcha_site_key){
        return <GoogleRecaptchaLazy
            onChange={onChange}
            recaptcha_site_key={recaptcha_site_key}
        />;
    }else if(captcha_provider === "turnstile"){
        return <TurnstileCaptchaRenderer
            site_key={turnstile_site_key}
            onChange={onChange}
        />;
    }else {
        return <DefaultCaptchaRenderer
                    onChange={onChange}
                />
    }
}
